import React from "react";
import { Location, Brand } from "../types/mapData";
import blackOval2 from "../../../../assets/images/map_v2/black-ovall-2.svg";
import blackOval from "../../../../assets/images/map_v2/black-ovall.svg";

interface BrandInfoProps {
  location: Location;
  brandToUse?: Brand;
  cloudinaryPath: string;
  userLocErr: boolean;
  handleBrandInfoClick: (
    location: Location,
    marker: google.maps.Marker,
    brandId?: number,
  ) => void;
  tags: Record<number, any> | null;
  getFeaturedTags: (brand?: Brand) => string[];
  loadingDetails: boolean;
  curMarkerRef?: React.RefObject<google.maps.Marker>;
  oval: string;
}

const BrandInfo: React.FC<BrandInfoProps> = ({
  location,
  brandToUse,
  cloudinaryPath,
  userLocErr,
  handleBrandInfoClick,
  tags,
  getFeaturedTags,
  loadingDetails,
  curMarkerRef,
  oval,
}) => {
  const locMarker = location.marker;
  const heroImage = brandToUse?.branding?.hero_image?.value ?? "";
  const heroUrl = heroImage.endsWith(".png")
    ? heroImage.replace(".png", ".jpg")
    : heroImage;
  const safeCloudinaryPath = cloudinaryPath.replace(/\/$/, "");

  const backgroundUrl = `${safeCloudinaryPath}/b_black,o_67,c_fit,w_240/${heroUrl}`;

  const logoUrl = brandToUse?.branding?.logo?.dark_mode
    ? `${safeCloudinaryPath}/w_104/${brandToUse.branding.logo.dark_mode}`
    : null;

  const featuredTags = tags ? getFeaturedTags(brandToUse) : [];

  const handleBrandMouseIn = (
    location: Location,
    locMarker: google.maps.Marker,
  ) => {
    if (!loadingDetails) {
      locMarker.setZIndex(1000);
      locMarker.setIcon({
        url: !!locMarker.isMulti ? blackOval : blackOval2,
        labelOrigin: new google.maps.Point(15.5, 14),
      });
    }
  };
  const handleBrandMouseOut = (
    location: Location,
    locMarker: google.maps.Marker,
  ) => {
    if (
      !loadingDetails &&
      locMarker.locName !== curMarkerRef?.current?.locName
    ) {
      locMarker.setZIndex(locMarker.saveZIndex ?? 0);
      locMarker.setIcon({
        url: oval,
        labelOrigin: new google.maps.Point(15.5, 14),
      });
    }
  };
  return (
    <div
      className="loc-container"
      onClick={() =>
        locMarker &&
        handleBrandInfoClick(location, locMarker, brandToUse?.brand_id)
      }
      onMouseEnter={() => locMarker && handleBrandMouseIn(location, locMarker)}
      onMouseLeave={() => locMarker && handleBrandMouseOut(location, locMarker)}
    >
      <div
        className="loc-tile"
        style={{ backgroundImage: `url(${backgroundUrl})` }}
      >
        {logoUrl && (
          <img
            src={logoUrl}
            className="loc-logo"
            alt={`${brandToUse?.name} Logo`}
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = "none";
            }}
          />
        )}
      </div>

      <div className="text-container">
        <div className="loc-header">{brandToUse?.name ?? "Unknown Brand"}</div>
        <div className="loc-subhead info-tags">
          {featuredTags.map((tag, brandId) => (
            <span key={`${brandId}-${tag}`}>{tag}</span>
          ))}
        </div>
        {!userLocErr && (
          <div className="loc-distance">{`${location.staticDistance ?? ""} Miles Away`}</div>
        )}
      </div>

      <div className="select-button"></div>
    </div>
  );
};

export default BrandInfo;
